/// <amd-module name="typeahead/features/CategorizeResultsByRegionType"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [
    {
        experiment: {
            id: 30368,
            name: "Group_Suggestions_by_RegionType",
            value: 1,
        },
        lobs: ["CARS"],
    },
];

const featureFlag = "categorize";

export class CategorizeResultsByRegionType implements IExperimentalFeature, IRequestUrlParamModifier {

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public modifyParameters(params: ISuggestServiceQueryParams,
                            context: IContext, options?: any): ISuggestServiceQueryParams {
        return addFeatureFlag(featureFlag, configuration, params, context);
    }

}
